module.exports = __webpack_public_path__ + "img/manual-slots-02-add-slot.bac19fdb.png";